import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

// Must match appId in capacitor.config.json and the URL scheme registered in
// AndroidManifest.xml / Info.plist, and be listed under Auth > URL
// Configuration > Redirect URLs in the Supabase dashboard.
export const NATIVE_AUTH_REDIRECT = 'com.decisivelabsllc.ultronic://auth-callback';

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

// Browsers download through an anchor element. A native WebView ignores that,
// so there the file is written to the app cache and handed to the share sheet.
export async function saveFile({ filename, blob }) {
  if (!isNative) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return;
  }

  const { uri } = await Filesystem.writeFile({
    path: filename,
    data: await blobToBase64(blob),
    directory: Directory.Cache,
  });
  try {
    await Share.share({ title: filename, files: [uri] });
  } catch (err) {
    // Dismissing the share sheet rejects; that is not a failed export.
    if (!/cancel/i.test(err?.message || '')) throw err;
  }
}
